export default __webpack_public_path__ + "static/media/img5.b400b69f.jpg";